import React from 'react'
import PropTypes from 'prop-types'
import { Pane, majorScale } from 'evergreen-ui'
import Category from './Category'
import SearchResult from './SearchResult'
import LoadingState from './LoadingState'
import InitialState from './InitialState'
import EmptyState from './EmptyState'

// Used to calculate "flat" item index, excluding category rows
const CATEGORY_COUNT = 4

const SearchResults = ({
  isEmpty,
  isLoading,
  searchTerm,
  searchResults,
  selectedItem,
  onClickSearchResult
}) => {
  const categories = Object.keys(searchResults)
  let selectedCategory

  if (selectedItem) {
    for (const category of categories) {
      const isIncluded = searchResults[category].includes(selectedItem)

      if (isIncluded) {
        selectedCategory = category
      }
    }
  }

  const nonEmptyCategories = categories.filter(category => {
    const items = searchResults[category] || []
    return items.length > 0
  })

  return (
    <Pane maxHeight={majorScale(70)} overflowY="auto">
      {isLoading && <LoadingState />}
      {!searchTerm && !isLoading && <InitialState />}
      {searchTerm && isEmpty && !isLoading && (
        <EmptyState searchTerm={searchTerm} />
      )}

      {!isEmpty &&
        nonEmptyCategories.map((category, categoryIndex) => {
          const items = searchResults[category]
          const isSelected = category === selectedCategory
          const selectedItemWithinCategory = isSelected ? selectedItem : null

          return (
            <Category
              key={category}
              hasTopBorder={categoryIndex > 0}
              name={category}
            >
              {items.map((item, itemIndex) => (
                <SearchResult
                  isSelected={isSelected && selectedItemWithinCategory === item}
                  searchIndex={categoryIndex * (CATEGORY_COUNT - 1) + itemIndex}
                  hasTopBorder={itemIndex > 0}
                  category={category}
                  item={item}
                  key={`${category}_${item.name}_${itemIndex + 1}`}
                  onClick={onClickSearchResult}
                />
              ))}
            </Category>
          )
        })}
    </Pane>
  )
}

SearchResults.propTypes = {
  isLoading: PropTypes.bool,
  searchResults: PropTypes.object.isRequired,
  searchTerm: PropTypes.string.isRequired,
  selectedItem: PropTypes.object,
  onClickSearchResult: PropTypes.func.isRequired
}

SearchResult.defaultProps = {
  isLoading: false
}

export default SearchResults
